// extracted by mini-css-extract-plugin
module.exports = {"Digits":"Digits_Digits__22lMy","Display":"Digits_Display__1Subi","CloseButton":"Digits_CloseButton__2FB1u","BackspaceIcon":"Digits_BackspaceIcon__2821R"};